/**
 * Visual Artifact Markers
 *
 * Chat marker helpers for structured visual artifacts.
 *
 * Primary responsibilities:
 * - Define the supported visual artifact marker syntax
 * - Parse marker JSON into validated visual artifacts
 *
 * Dependencies:
 * - Visual artifact validation
 */

import type { VisualArtifact } from './types'
import { isVisualArtifact } from './validation'

export const VISUAL_ARTIFACT_MARKER_REGEX = /\[VISUAL_ARTIFACT\](.*?)\[\/VISUAL_ARTIFACT\]/gs

export function parseVisualArtifactMarkerPayload(value: string): VisualArtifact | null {
  try {
    const parsed = JSON.parse(value) as unknown
    return isVisualArtifact(parsed) ? parsed : null
  } catch {
    return null
  }
}
